export enum GoalsStatus {
  InProgress = 'In progress',
  Achieved = 'Achieved',
  Canceled = 'Canceled',
}
